module.exports = __webpack_public_path__ + "img/filterIcon.6b742214.svg";